// InvalidateApplicationModal.jsx — ARQUIVO COMPLETO
import { useState } from "react";
import { Ban, Gift, X, AlertTriangle, Send } from "lucide-react";
import "./InvalidateApplicationModal.scss";

function formatCurrency(value) {
  const numbers = value.replace(/\D/g, '');
  if (!numbers) return '';
  const cents = parseInt(numbers, 10);
  const reais = (cents / 100).toFixed(2);
  return reais.replace('.', ',');
}

function parseCurrency(formatted) {
  const clean = formatted.replace(/\./g, '').replace(',', '.');
  return parseFloat(clean) || 0;
}

export default function InvalidateApplicationModal({ onConfirm, onClose }) {
  const [bonusAmount, setBonusAmount] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const currentBonusValue = parseCurrency(bonusAmount);

  const handleAmountChange = (e) => {
    setBonusAmount(formatCurrency(e.target.value));
  };

  const handleConfirm = async () => {
    setSubmitting(true);
    try {
      await onConfirm(currentBonusValue > 0 ? currentBonusValue : null);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="iam-overlay" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="iam-modal">
        <div className="iam-header">
          <h3 className="iam-title">
            <Ban size={20} />
            Invalidar candidatura
          </h3>
          <button className="iam-close" onClick={onClose} aria-label="Fechar">
            <X size={20} />
          </button>
        </div>

        <p className="iam-text">
          <AlertTriangle size={16} style={{ marginRight: 8, verticalAlign: 'middle' }} />
          A vaga será reaberta como <strong>urgente</strong>, visível só para freelancers a até
          5km de distância. Se quiser atrair um substituto mais rápido, ofereça um bônus abaixo
          (opcional) — o valor sai da sua carteira e é somado ao pagamento da vaga.
        </p>

        <div className="iam-field">
          <label className="iam-label">
            <Gift size={16} />
            Bônus para quem aceitar (opcional)
          </label>
          <div className="iam-input-prefix">
            <span className="iam-prefix">R$</span>
            <input
              className="iam-input"
              type="text"
              inputMode="numeric"
              placeholder="0,00"
              value={bonusAmount}
              onChange={handleAmountChange}
            />
          </div>
          <span className="iam-hint">
            Esse valor será reservado na sua carteira e somado ao valor pago ao próximo freelancer.
          </span>
        </div>

        <div className="iam-actions">
          <button className="iam-btn iam-btn--outline" onClick={onClose} disabled={submitting}>
            Cancelar
          </button>
          <button className="iam-btn iam-btn--danger" onClick={handleConfirm} disabled={submitting}>
            {submitting ? (
              <>
                <span className="iam-spinner" />
                Reabrindo...
              </>
            ) : (
              <>
                <Send size={16} />
                Confirmar e reabrir
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
}